
import { React , useState  , useRef } from 'react';
import { Container , Row , Col } from 'reactstrap';
import Commonsection from '../component/UI/Common-section/Commonsection';

function  Contact ()  {


    const nameRef = useRef('');
    const emailRef = useRef('');
    const subjectRef = useRef('');
    const messageRef = useRef('');


    const handelForm = (e) => {
        e.preventDefault();
    }

    return(

        <>
            <Commonsection   title='Contact'/>
            <section  className=''>
                <Container >
                    <Row >
                        <Col lg="6"  md="6"  className='m-auto  text-center'>
                            <h2> Dreop Your Message   </h2>
                            <p> Hi you can set Your message Here .. </p>

                            <div  className='contact  mt-4  '>
                                <form  onSubmit={handelForm}  action='' className=''>  
                                    <div className='form__input'>
                                        <input type='text'  placeholder='Enter Your Name ' ref={nameRef}  />
                                    </div>

                                    <div className='form__input'>
                                        <input type='email'  placeholder='Enter Your Email '  ref={emailRef}  />
                                    </div>

                                    <div className='form__input'>
                                        <input type='text'  placeholder='Enter Your Subject '  ref={subjectRef} />
                                    </div>

                                    <div className='form__input'>
                                        <textarea
                                            name=''
                                            id=''
                                            color='30'
                                            rows="7"
                                            placeholder='write Message  '
                                            ref={messageRef}
                                        >
                                        </textarea>
                                    </div>

                                    <button  
                                        style={{ border:'none' , padding:"7px  25px" , borderRadius: "5px"  , marginTop: "20px" }}  
                                        className='send__btn  
                                    '>  
                                        Send a Message 
                                    </button>
                                    
                                </form>
                            </div>

                        </Col>
                    </Row>
                </Container>
                
            </section>
        </>
    );
}

export default Contact;

